var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRocketIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.549,20.227v-3.947c0-8.806-3.725-14.125-5.283-15.964C16.098,0.116,15.851,0.002,15.591,0 c-0.261-0.001-0.508,0.112-0.679,0.31c-1.584,1.835-5.384,7.156-5.384,15.97v3.948l-0.729,0.491 c-1.405,0.948-2.248,2.533-2.248,4.229v4.711c0,0.279,0.154,0.537,0.4,0.67c0.247,0.132,0.546,0.117,0.778-0.039l2.368-1.577 c0.665-0.442,1.445-0.679,2.244-0.679h1.741v2.283c0,0.42,0.34,0.76,0.759,0.76h1.394c0.419,0,0.759-0.34,0.759-0.76v-2.283h1.74 c0.799,0,1.58,0.235,2.246,0.68l2.366,1.576c0.232,0.156,0.531,0.171,0.778,0.039c0.246-0.133,0.4-0.391,0.4-0.67v-4.711 c0-1.694-0.844-3.279-2.248-4.229L21.549,20.227z M15.539,14.043c-1.446,0-2.62-1.173-2.62-2.619c0-1.447,1.174-2.619,2.62-2.619 c1.445,0,2.619,1.172,2.619,2.619C18.158,12.87,16.984,14.043,15.539,14.043z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocketIcon);
export default __webpack_public_path__ + "static/media/rocketIcon.f32dcdfd94ef917f71650c0afed90b6b.svg";
export { ForwardRef as ReactComponent };